// File: src/components/Sidebar.js

import React from "react";
import TreeList, { Scrolling, Column, SearchPanel } from "devextreme-react/tree-list";
import 'devextreme/dist/css/dx.light.css';

// --- ★★★ [수정] sidebarOpen prop을 새로 받습니다. ★★★ ---
export default function Sidebar({ items, onSelect, sidebarOpen }) {

  const onRowClick = (e) => {
    if (e.data && e.node && !e.node.hasChildren) {
      onSelect(e.data);
    }
  };

  // --- ★★★ [수정] 사이드바의 열림/닫힘 상태에 따른 스타일 동적 변경 ★★★ ---
  const sidebarStyle = {
    width: sidebarOpen ? 250 : 0, // 닫혔을 때 너비를 0으로 설정
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    borderRight: sidebarOpen ? '1px solid #ddd' : 'none', // 닫혔을 때 오른쪽 테두리 제거
    backgroundColor: '#fff',
    flexShrink: 0,
    transition: 'width 0.3s ease', // 부드러운 전환 효과
    overflow: 'hidden' // 너비가 줄어들 때 내용이 삐져나오지 않도록
  };

  return (
    <aside style={sidebarStyle}>
      {/* --- ★★★ [수정] 내용 전체를 감싸서 한번에 숨김 처리 ★★★ --- */}
      <div style={{ padding: '10px', minWidth: '230px' }}> {/* 내용이 줄어들지 않도록 최소 너비 지정 */}
        <TreeList
          dataSource={items}
          keyExpr="id"
          parentIdExpr="parentId"
          showBorders={false}
          showRowLines={true}
          columnAutoWidth={true}
          height="calc(100vh - 80px)"
          onRowClick={onRowClick}
          wordWrapEnabled={true}
        >
          <SearchPanel visible={true} placeholder="Search menu..." />
          <Scrolling mode="standard" />
          <Column dataField="text" caption="Menu" />
        </TreeList>
      </div>
    </aside>
  );
}